import React, { useState } from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import * as qs from 'qs';
import config from 'react-global-configuration';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useHistory } from 'react-router-dom';
import {
  SearchItem,
} from '../../../components';

import * as query from '../../../components/HomepageSearch/query.graphql';
import { SearchFacets } from '../../../components/SearchKit/SearchFacets';
import { SelectFacet } from '../../../components/SearchKit/SelectFacet';

import '../../Node/HomePage/style.scss';
import './style.scss';
import SearchLoadMore from '../../../components/SearchKit/SearchLoadMore';
import SearchKitVNL from '../../../components/SearchKit';
import SearchResults from '../../../components/SearchKit/SearchResults';
import { DOMAIN_VNL } from '../../../config/constants';

const facetToSplitIdentifier = 'field_type_of_information_name';


const SearchHeader = ({ data }) => {
  return (
    <span />
  );
};

const ParagraphWizardResultsOverview = ({ entity }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [filters, setFilters] = useState([]);
  const [labels, setLabels] = useState([]);
  const [splitFacetUsed, setSplitFacetUsed] = useState([]);

  const currentDomainIsVNL = config.get('CURRENT_DOMAIN') === DOMAIN_VNL;
  const queryString = qs.parse(window.location.search.replace('?filters=', ''));
  const queryFilters = Object.values(queryString);

  const onFilterChange = (newFacets, newFilters) => {
    const facetToSplit = newFacets.find((facet) => { return facet.identifier === facetToSplitIdentifier; });
    const newLabels = facetToSplit.entries.map((entry) => {
      return entry.label;
    });

    const newFacetToSplitUsed = newFilters.find((facet) => { return facet.identifier === facetToSplitIdentifier; });
    setSplitFacetUsed(!!newFacetToSplitUsed);

    if (JSON.stringify(newFilters) !== JSON.stringify(filters)) {
      setFilters(newFilters);
      const newQueryString = qs.stringify(newFilters);

      if (currentDomainIsVNL) {
        history.push(`/kennisaanbod?filters=${newQueryString}`);
      } else {
        history.push(`/adviezen?filters=${newQueryString}`);
      }
    }

    if (JSON.stringify(newLabels) !== JSON.stringify(labels)) {
      setLabels(newLabels);
    }
  };

  const defaultFilters = Immutable.List(queryFilters);

  let combinedFilters = Immutable.List(labels.map((label) => {
    return [{
      identifier: facetToSplitIdentifier,
      value: label,
    }].concat(queryFilters);
  }));

  if (splitFacetUsed) {
    combinedFilters = Immutable.List([queryFilters]);
  }

  const pageSize = splitFacetUsed ? 12 : 3;

  return (
    <div className="Paragraph WizardResultsOverview">
      <Container>
        <div className="row">
          <div className="col-lg-12">
            <div className="NodeHomePage__wizard">
              {entity.getIn(['field_homepage_wizard_title', 0, 'value']) && (
                <>
                  <h2>{entity.getIn(['field_homepage_wizard_title', 0, 'value'])}</h2>
                  <p>{entity.getIn(['field_homepage_wizard_subtitle', 0, 'value'])}</p>
                </>
              )}

              <div className="NodeHomePage__wizard__filters">
                {/* SearchKit only for faceting */}
                <SearchKitVNL
                  query={query}
                  pageSize={1}
                  defaultFilters={defaultFilters.toJS()}
                >
                  {(data, loading) => data && (
                    <div className="Search__results">
                      <div className="Search__results__title">
                        <h3>Filters</h3>
                        <span className="expand" />
                      </div>
                      <div className="Search__results__filters__wrapper">
                        <div className="Search__results__filters">
                          <div className="Search__results__filters__items">
                            <SearchFacets onChange={onFilterChange} data={data.wizard} loading={loading} facets={[SelectFacet]} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </SearchKitVNL>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <div className="WizardResultsOverview__search__results__wrapper">
        <Container>
          {/* SearchKit for results, with applied filters */}
          {currentDomainIsVNL && combinedFilters.map((filterPerType, key) => {
            return (
              <div className="WizardResultsOverview__search__results__wrapper__inner">
                <SearchKitVNL
                  key={JSON.stringify(filterPerType)}
                  query={query}
                  pageSize={pageSize}
                  defaultFilters={filterPerType}
                >
                  {
                    (data, loading, ...props) => (
                      <>
                        {data && data.wizard.results.summary.total > 0 && (
                          <div className="row">
                            <div className="col-12 col-lg-9">
                              <h3>{labels[key]}</h3>
                            </div>
                            <div className="col-12 col-lg-3">
                              <div className="total-count minimized">
                                {data.wizard.results.summary.total} {t('general.search_results')}
                              </div>
                            </div>
                          </div>
                        )}

                        <SearchResults
                          data={data ? data.wizard : []}
                          renderItem={SearchItem}
                          renderHeader={SearchHeader}
                          appendResults
                        />
                        <SearchLoadMore data={data ? data.wizard : null} />
                      </>
                    )
                  }
                </SearchKitVNL>
              </div>
            );
          },
          )}
          {!currentDomainIsVNL && (
            <div className="WizardResultsOverview__search__results__wrapper__inner">
              <SearchKitVNL
                key={JSON.stringify(defaultFilters.toJS())}
                query={query}
                pageSize={15}
                defaultFilters={defaultFilters.toJS()}
              >
                {
                  (data, loading, ...props) => (
                    <>
                      {(data && data.wizard.results.summary.total > 0) && (
                        <p className="Search__results-header">
                          {data.wizard.results.summary.total} {(data.wizard.results.summary.total > 1 || data.wizard.results.summary.total === 0) ? 'Resultaten' : 'Resultaat'}
                        </p>
                      )}
                      <SearchResults
                        data={data ? data.wizard : []}
                        renderItem={SearchItem}
                        renderHeader={SearchHeader}
                        appendResults
                      />
                      <SearchLoadMore data={data ? data.wizard : null} />
                    </>
                  )
                }
              </SearchKitVNL>
            </div>
          )}
        </Container>
      </div>
    </div>
  );
};

export default ParagraphWizardResultsOverview;
